import { fetchStatistics, type StatsCard } from '@/services/statistics';

export default function StatsCardsRow() {
  const [statsCards, setStatsCards] = useState<StatsCard[] | null>(null);

  useEffect(() => {
    let mounted = true;
    fetchStatistics().then((stats) => {
      if (mounted && stats) setStatsCards(stats.statsCards);
    });
    return () => { mounted = false; };
  }, []);

  if (!statsCards) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="card p-4 animate-pulse">
            <div className="h-9 w-9 rounded-full bg-background-200 mb-3" />
            <div className="h-7 w-16 rounded bg-background-200 mb-1" />
            <div className="h-3 w-20 rounded bg-background-200" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {statsCards.map((card) => (
        <div
          key={card.label}
          className="card p-4 transition-all duration-200 hover:shadow-gold hover:scale-[1.02] cursor-default"
        >
          <span className={`w-9 h-9 rounded-full flex items-center justify-center mb-3 ${card.bg}`}>
            <i className={`${card.icon} ${card.color} text-base`} />
          </span>
          <p className="font-display text-[28px] leading-none font-bold text-foreground-950 mb-1.5">{card.value}</p>
          <p className="text-[11px] font-medium text-foreground-400 uppercase tracking-wide whitespace-nowrap">{card.label}</p>
        </div>
      ))}
    </div>
  );
}